import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import errorLoadImg from '../assets/img/common/load_error_1.png'

Vue.use(VueLazyLoad, {
  error: errorLoadImg,
  loading: '',
  attempt: 1
})
